// frontend/src/pages/LoginPage.jsx
import React, { useState, useEffect } from 'react';
import { login } from '../services/auth';
import { Button, TextField, Container, Typography , 
CircularProgress, Box, LinearProgress, Checkbox, FormControlLabel } from '@mui/material';
import { useNavigate , Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { logMetric } from '../services/metrics';

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0); // Define el estado de progreso
 const [captchaToken, setCaptchaToken] = useState(null); // Token del reCAPTCHA

  const navigate = useNavigate();

  function LoginPage() {
    useEffect(() => {
      logMetric('login_page', 'visit'); // Registra la visita a la página
    }, []);

    /* const handleSubmit = (e) => {
        e.preventDefault();
        logMetric('login_page', 'submit_form');
        // Manejar el inicio de sesión...
      };
    */
      return (
        <form onSubmit={handleSubmit}>
          {/* Formulario */}
        </form>
      );
    }
    

  useEffect(() => {
    if (loading) {
      const interval = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress === 100) {
            clearInterval(interval);
            return 100; // Detén el progreso cuando llegue al 100%
          }
          return Math.min(oldProgress + 10, 100); // Incrementa 10% cada 300ms
        });
      }, 300);

      return () => {
        clearInterval(interval); // Limpia el intervalo al desmontar
      };
    } else {
      setProgress(0); // Reinicia el progreso cuando `loading` sea `false`
    }
  }, [loading]);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true); // Activa el efecto de carga

    try {
        await new Promise((resolve) => setTimeout(resolve, 2000)); // 3 segundos de retraso simulado
        const { access_token } = await login(username, password);
        onLogin(access_token); // Notifica al componente App que el usuario ha iniciado sesión
        navigate('/admin'); // Redirige al panel de administración
    } catch (error) {
        console.error(error);
        alert('Error en el inicio de sesión');
    }  finally {
        setTimeout(() => setLoading(false), 2000); // Agrega un retraso de 1 segundo
    }
}

const handleCaptchaChange = (token) => {
   setCaptchaToken(token); // Guarda el token de reCAPTCHA
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (!captchaToken) {
      alert('Por favor, completa el reCAPTCHA.');
      return;
    }
    setLoading(true); // Activa el efecto de carga
    try {
        await new Promise((resolve) => setTimeout(resolve, 2000)); // 2 segundos de retraso simulado
        const { access_token } = await login(username, password /*, captchaToken*/);
        onLogin(access_token); // Notifica al componente App que el usuario ha iniciado sesión
        navigate('/admin'); // Redirige al panel de administración
      } catch (error) {
        console.error(error);
        alert('Error en el inicio de sesión');
      } finally {
        setTimeout(() => setLoading(false), 2000); // Agrega un retraso de 1 segundo
      }
    }

return (
    
    <Box
    sx={{
      backgroundImage: 'url(/images/plaguicidas.jpg)', // Ruta de la imagen de fondo
      backgroundSize: 'cover', // Ajusta la imagen para que cubra toda el área
      backgroundPosition: 'center', // Centra la imagen
      height: '100vh', // Altura completa de la pantalla
      display: 'flex', // Usa flexbox para centrar el contenido
      alignItems: 'center', // Centra verticalmente
      justifyContent: 'center', // Centra horizontalmente
    }}
  >
    
    <Container maxWidth="sm" style={{ marginTop: '5rem', textAlign: 'center' }}>
    <Box
      sx={{
        boxShadow: 3,
        padding: 4,
        borderRadius: 3,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        maxWidth: 400,
        margin: 'auto',
      }}
    >
      <Typography variant="h5" gutterBottom>
        Inicio de sesión del administrador
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Username"
          variant="outlined"
          fullWidth
          margin="normal"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <TextField
          label="Password"
          type="password"
          variant="outlined"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2 }}>
          
        </Box>

<Box sx={{ mt: 2 }}>
<ReCAPTCHA
  sitekey="6LdGbKIqAAAAAKB_prbD0qaQzPCSJ2sKX-og2s74" 
  onChange={handleCaptchaChange}
/>
            </Box> 



        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          disabled={loading}
          sx={{ marginTop: 2 }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'LOGIN'}
        </Button>
        {loading && (
          <Box sx={{ width: '100%', mt: 2 }}>
<LinearProgress variant="determinate" value={progress} />
</Box>
        )}
      </form>
    </Box>
  </Container>
  </Box> 
);
}